import styled from 'styled-components';
import { ActionButton } from "components/ModelButton";
import Text from "components/Text";
import { abrirProtocoloAction, eventName } from 'components/ApplicationInsights/eventNames';

export const ContainerTracking = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #FCFBFB;
  margin-bottom: 0.8em;

  @media screen and (max-width: 586px) {
    flex-direction: column;
    padding: 40px 0;
  }
`;

export const ImgNoTracking = styled.img``;

export const ContainerDescription = styled.div`
  margin-left: 40px;

  @media screen and (max-width: 586px) {
    margin-left: 0;
  }
`;

export const TitleTracking = styled(Text).attrs({
  className: "font-bold color-primary mb-1",
  size: 15
})`
  @media screen and (max-width: 586px) {
    text-align: center;
    margin-top: 1em;
  }
`;

export const DescriptionTracking = styled(Text).attrs({
  className: "color-blue-gray",
  size: 13
})`
  @media screen and (max-width: 586px) {
    text-align: center;
    margin-top: 1em;
    white-space: inherit;
  }
`;

export const BtnTracking = styled(ActionButton).attrs({
  textButton: "Solicitar Tracking",
  trackName: abrirProtocoloAction.REGISTRAR_TRACKING_INDISPONIVEL,
  trackItem: eventName.ABRIR_PROTOCOLO,
  noTracking: true
})`
  width: 200px;
  margin-top: 10px;

  @media screen and (max-width: 586px) {
    margin: 10px auto 0;
  }
`;